import { useAccountData } from "../firebase";
import { carbonUnitTypes } from "../otherHelpers";

const useInputMeasurementSystem = () => {
  const [{ inputMeasurementSystem, measurementSystem }] = useAccountData();
  const activeSystem = inputMeasurementSystem || measurementSystem;

  const carbonUnit = activeSystem === "imperial" ? "lbs" : "tons";
  const { converter, name } = carbonUnitTypes.find(
    ({ short }) => short === carbonUnit
  );

  return {
    measurementSystem: activeSystem,
    carbonUnit,
    carbonUnitLabel: name,
    convertCarbonUnits: converter,
  };
};
export default useInputMeasurementSystem;
